import ILanguage from '@/assets/lang/ILanguage';

const es: ILanguage = {
  generic: {
    developedBy: 'Desarrollado por',
    loading: 'Cargando, por favor espere',
    anonymousEvaluation: 'Evaluar en anonimato',
    acceptanceContact: 'Acepto ser contactado',
    chooseTheChannelToContact: 'Elija la mejor manera para que nos comuniquemos con usted',
    whatsapp: 'Whatsapp',
    phone: 'Teléfono',
    email: 'Email',
    like: 'Me gusta',
    back: 'Volver',
    skipAnswer: 'No responder',
    scoreOption: 'Puntuación {score}',
    noScore: 'Ninguna puntuación',
    progress: 'Progreso de la encuesta',
    paidSurveyFrameTitle: 'Encuestas remuneradas',
    dislike: 'No me gusta',
    forceAnonymousEvaluation: 'Encuesta anónima',
  },

  preEnrichment: {
    title: 'Búsqueda de satisfacción',
    subtitle: 'Complete la siguiente información para iniciar la búsqueda:',
    error: 'Hubo un problema al registrarse, intente nuevamente.',
  },

  enrichment: {
    title: 'Ingrese la siguiente información',
    requiredField: 'Campo obligatorio',
    invalidDocument: 'Documento no válido',
    invalidEntityDocument: 'Documento de La Entidad no válido',
    invalidDate: 'Fecha invalida',
    labelName: 'Nombre',
    PlaceholderName: 'Nombre Apellido',
    labelEmail: 'Correo Electrónico',
    labelGender: 'Género',
    maleGender: 'Masculino',
    femaleGender: 'Mujer',
    otherGender: 'Otro',
    zipcode: 'Código Postal',
    state: 'Estado',
    statePlaceholder: 'SP',
    city: 'Ciudad',
    cityPlaceholder: 'São José dos Campos',
    neighbor: 'Barrio',
    neighborPlaceholder: 'Jardim Veneza',
    address: 'Lugar',
    addressPlaceholder: 'Rua João das Neves',
    number: 'Número',
    complement: 'Complemento',
    labelPhone: 'Teléfono',
    labelBirth: 'Fecha de nacimiento',
    labelDocument: 'DNI',
    labelEntityDocument: 'Documento de la entidad',
    labelDocumentOrEntityDocument: 'DNI o el Documento de Entidad',
    maskDocument: '###.###.###-##',
    start: 'COMIENZO',
    finish: 'TERMINAR',
    skip: 'omitir',
    send: 'MANDAR',
  },

  errorMessages: {
    opsText: '¡Uy!',
    unexpectedError: '¡Uy! Encuesta no disponible en este momento',
    unexpectedErrorDetails: 'Encuesta no disponible en este momento',
    missingItem: 'Hay preguntas sin responder',
    missingScore: 'Seleccioná una calificación de 0 a 10',
    missingScoreCSAT: 'Seleccioná una calificación de 1 a 5',
    missingScoreCES: 'Seleccioná una calificación de 1 a 7',
    surveyAlreadyDone: 'Esta encuesta ya fue realizada.',
    surveyAlreadyDoneDetails: 'No es posible realizar la encuesta nuevamente.',
    surveyNotFound: '¡Uy! Calificación no encontrada.',
    surveyNotFoundDetails:
      'Lamentablemente hubo un fallo, pero asegurate de evaluar la próxima encuesta. Tu opinión es muy importante para nosotros.',
    surveyExpired: 'El período para realizar esta encuesta ha expirado.',
    surveyExpiredDetails: 'Lamentablemente, esta encuesta ya no está disponible.',
    surveyInvalidScore: '¡Uy! Nota inválida',
    surveyInvalidScoreDetails: 'Ingresaste una nota no válida para este tipo de encuesta.',
    surveyInativeJourney: '¡Uy! Encuesta no disponible en este momento',
    surveyInativeJourneyDetails: 'Encuesta no disponible en este momento',
    SURVEY_SUSPENDED: 'Campaña finalizada',
    SURVEY_SUSPENDEDDetails: 'No dejes de calificarnos en tu próxima experiencia. Tu opinión es muy importante',
    surveyBlocked: '¡Uy! Encuesta no disponible en este momento',
    surveyBlockedDetails: 'Encuesta no disponible en este momento',
    'Survey blocked': '¡Uy! Encuesta no disponible en este momento',
    'Survey blockedDetails': 'Encuesta no disponible en este momento',
    'survey blocked': '¡Uy! Encuesta no disponible en este momento',
    'survey blockedDetails': 'Encuesta no disponible en este momento',
    'Journey is required for this instance': '"journey" no proporcionado',
    'Journey is required for this instanceDetails': 'Se requiere "Journey" para esta instancia',
    'Transaction already rated': 'Esta encuesta ya fue realizada.',
    'Transaction already ratedDetails': 'No es posible realizar la encuesta nuevamente.',
  },

  unsubscribe: {
    title: '¡Que pena!',
    titleDescription:
      'Nuestra intención siempre ha sido ofrecerle la mejor experiencia posible. Cuando se da de baja, ya no recibirá las encuestas de satisfacción de ',
    descriptionAfter: ' será cancelado.',
    error: 'No se puede cancelar la suscripción del correo electrónico',
    thanks: 'Gracias',
    form: {
      question: 'Por favor, indique el motivo de su partida:',
      answer1: 'Ya no quiero dar mi opinión',
      answer2: 'Estoy recibiendo muchos contactos',
      answer3: 'Esta búsqueda no me interesa.',
      answer4: 'Otra razon',
      send: 'enviar',
    },
  },

  selectBelow: 'Seleccione uno de los botones siguientes',
  totallyDisagree: 'Extremadamente difícil',
  Disagree: 'Muy difícil',
  partiallyDisagree: 'Razonablemente difícil',
  Neutral: 'Neutral',
  partiallyAgree: 'Bastante Fácil',
  Agree: 'Muy fácil',
  stronglyAgree: 'Extremadamente Fácil',
  howCouldWeImprove: '¿Como podemos mejorar?',
  leaveYourSuggestionHere: 'Deja tu sugerencia aquí.',
  requiredLabel: 'Obligatorio',
  isRequiredField: 'Es necesario llenar este campo',
  clickOnButton: 'Haga clic en el botón',
  skipOrClickOnButton: 'Saltar o hacer clic en el botón',
  toNotAnswerQuestion: 'no responder una pregunta',
};

export default es;
